export default __webpack_public_path__ + "static/media/100_39253.8b95dc07.jpg";